export { default } from './useScrollTrigger';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/useScrollTrigger/index.js
// module id = 833
// module chunks = 121